import ContactValidation from './ContactValidation'
import Employee from './Employee'
export class SaveContactValidationRequest {
    ContactValidation: ContactValidation;
    SavedByEmployee: Employee;
}

export default SaveContactValidationRequest;